const $$splitComponentImporter = () => import('/home/runner/work/nexus/nexus/apps/frontend/src/routes/(unauthenticated)/idp-login.tsx?tsr-split=component');
import { lazyRouteComponent } from '@tanstack/react-router';
import { createFileRoute } from '@tanstack/react-router';
import { zodValidator } from '@tanstack/zod-adapter';
import { z } from 'zod';
const searchSchema = z.object({
  org: z.string().optional()
});
export const Route = createFileRoute('/(unauthenticated)/idp-login')({
  component: lazyRouteComponent($$splitComponentImporter, 'component'),
  validateSearch: zodValidator(searchSchema)
});

// IdP-initiated SAML login lands here after Auth0 validates the assertion. Our SPA
// uses authorization-code + PKCE, so the code Auth0 appends has no matching local
// transaction and can't be consumed (authProvider skips the callback on this path).
// Instead we re-initiate a normal login: Auth0's SSO session is now live, so it is
// silent. When the connection's organization is supplied we scope the login to it so
// the user lands directly in that org without re-selecting one.